import { motion, useScroll, useSpring, useTransform } from "framer-motion";

/**
 * Scroll-parallax wrapper: children drift along the scroll with a springy,
 * finger-following feel. speed < 0 floats upward, speed > 0 drifts down.
 */
export default function ParallaxLayer({ speed = -80, className = "", style = {}, children, testid }) {
    const { scrollY } = useScroll();
    const rawY = useTransform(scrollY, [0, 3400], [0, speed]);
    const y = useSpring(rawY, { stiffness: 55, damping: 18, mass: 0.6 });

    return (
        <motion.div
            aria-hidden="true"
            data-testid={testid}
            className={className}
            style={{ ...style, y }}
        >
            {children}
        </motion.div>
    );
}
